import { render } from "./PreFooterContainer.vue?vue&type=template&id=687c7b62"
import script from "./PreFooterContainer.vue?vue&type=script&lang=js"
export * from "./PreFooterContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/PreFooterContainer/PreFooterContainer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "687c7b62"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('687c7b62', __exports__)) {
    api.reload('687c7b62', __exports__)
  }
  
  module.hot.accept("./PreFooterContainer.vue?vue&type=template&id=687c7b62", () => {
    api.rerender('687c7b62', render)
  })

}


export default __exports__